import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';

import { Block } from '../Block';
import { Typography } from '../Typography';
import { Button } from '../Button';
import { NotFound } from './NotFound';

interface IProps {
  handleResetSearch: () => void;
}

export const VacanciesNotFound: React.FC<IProps> = ({ handleResetSearch }) => {
  const deviceType = useDeviceType();

  return (
    <NotFound>
      <Block marginTop={8}>
        <Typography.Text level={4}>
          Не нашли подходящих вакансий по вашему запросу, попробуйте изменить параметры поиска
        </Typography.Text>
      </Block>

      {deviceType !== 'desktop' && (
        <Block marginTop={24}>
          <Button onClick={handleResetSearch}>Изменить запрос</Button>
        </Block>
      )}
    </NotFound>
  );
};

VacanciesNotFound.displayName = 'VacanciesNotFound';
